/**
 * Helpers for persisted support-ticket transcripts.
 *
 * @copyright 2025 Glimbr Pty Ltd
 * @version 2026-04-27-v1
 */
import type { SupportTicketPatch, TicketMessage } from './types';

export function getSupportTranscriptLabel(message: TicketMessage): string {
    if (isInternalTicketMessage(message)) return 'Internal note';
    if (message.author_type === 'system' || message.direction === 'system') return 'System';
    if (message.author_type === 'glimbr_ai' || message.author_type === 'assistant') {
        return 'Assistant';
    }
    if (message.author_type === 'admin') return 'Admin';
    return 'User';
}

export function isInternalTicketMessage(message: TicketMessage): boolean {
    return (
        message.direction === 'internal_note' ||
        message.author_type === 'internal_note' ||
        message.visible_to_customer === false
    );
}

export function normalizeTicketPatch(patch: SupportTicketPatch): SupportTicketPatch {
    return {
        ...patch,
        assignee:
            typeof patch.assignee === 'string' ? patch.assignee.trim() || null : patch.assignee
    };
}
